import React, { memo, useCallback } from 'react';

/**
 * DecisionToggle - Decision choices toggle for decision nodes
 * Shows clickable option buttons and an "add/edit" button
 */
const DecisionToggle = memo(({
  taskId,
  decisionOptions,
  decisionAnswer,
  onDecisionAnswerChange,
  onOpenOptionsModal,
}) => {
  const handleOptionClick = useCallback((optionId) => (e) => {
    e.stopPropagation();
    onDecisionAnswerChange?.(taskId, optionId === decisionAnswer ? null : optionId);
  }, [taskId, decisionAnswer, onDecisionAnswerChange]);

  return (
    <div className="todo-item__decision-toggle">
      {decisionOptions.map((option) => (
        <button
          key={option.id}
          className={`todo-item__decision-btn ${decisionAnswer === option.id ? 'todo-item__decision-btn--active' : ''}`}
          style={{ '--option-color': option.color }}
          onClick={handleOptionClick(option.id)}
          title={option.label}
        >
          {option.label}
        </button>
      ))}
      <button
        className="todo-item__decision-add-btn"
        onClick={(e) => {
          e.stopPropagation();
          onOpenOptionsModal?.();
        }}
        title="Add or edit choices"
      >
        +
      </button>
    </div>
  );
});

DecisionToggle.displayName = 'DecisionToggle';

export default DecisionToggle;
